import Button from "Components/Common/Button/Button";
import { DrawListItem, PENDING_DRAW_STATUSES } from "../DrawHistory.types";

interface DrawSelectorProps {
  draws: DrawListItem[];
  selectedDrawId: string;
  onSelectDraw: (drawId: string) => void;
  onExportPdf: () => void;
  onExportAll: () => void;
  exportingPdf?: boolean;
  exportingAll?: boolean;
}

const DrawSelector = ({
  draws,
  selectedDrawId,
  onSelectDraw,
  onExportPdf,
  onExportAll,
  exportingPdf = false,
  exportingAll = false,
}: DrawSelectorProps) => {
  if (draws.length === 0) return null;

  return (
    <div className="drawSelector">
      <span className="dsLabel">Draw:</span>
      {draws.map((draw) => {
        const isPending = PENDING_DRAW_STATUSES.includes(draw.status ?? "");
        const isActive = draw.id === selectedDrawId;
        return (
          <Button
            key={draw.id}
            type="button"
            className={`dsBtn${isActive ? " active" : ""}${isPending ? " pending" : ""}`}
            onClick={() => onSelectDraw(draw.id)}
          >
            {String(draw.drawNumber).padStart(2, "0")}
            {isPending ? " ⏳" : ""}
          </Button>
        );
      })}
      <span className="dsActions">
        <Button
          type="button"
          className="btn secondary sm"
          onClick={onExportPdf}
          disabled={exportingPdf}
        >
          {exportingPdf ? "Generating…" : "📄 Export PDF"}
        </Button>
        <Button
          type="button"
          className="btn secondary sm"
          onClick={onExportAll}
          disabled={exportingAll}
        >
          {exportingAll ? "Generating…" : "📦 Export All"}
        </Button>
      </span>
    </div>
  );
};

export default DrawSelector;
